import safeLocalStorage from 'common/support/safeLocalStorage';
import { VideoCtvRedux } from 'store-types';
import { AppDispatch } from 'app-types';

export const ENABLE_CLOSED_CAPTIONING = 'ENABLE_CLOSED_CAPTIONING' as const;
export const DISABLE_CLOSED_CAPTIONING = 'DISABLE_CLOSED_CAPTIONING' as const;
const CAPTIONS_KEY = 'captionsEnabled';

export const enableClosedCaptioning = () => {
  safeLocalStorage.setItem(CAPTIONS_KEY, true as unknown as string);

  return { type: ENABLE_CLOSED_CAPTIONING };
};

export const disableClosedCaptioning = () => {
  safeLocalStorage.setItem(CAPTIONS_KEY, false as unknown as string);

  return { type: DISABLE_CLOSED_CAPTIONING };
};

export const toggleClosedCaptioning = () => (dispatch: AppDispatch<VideoCtvRedux>, getState: () => VideoCtvRedux) => {
  const { closedCaptioning } = getState();

  const action = closedCaptioning
    ? disableClosedCaptioning()
    : enableClosedCaptioning();

  dispatch(action);
};

export const setupClosedCaptioning = () => {
  const enabled = JSON.parse(safeLocalStorage.getItem(CAPTIONS_KEY));

  return enabled ? enableClosedCaptioning() : disableClosedCaptioning();
};
